export default "<div>\n    <ng-content select=\"button[mat-raised-button]\"></ng-content>\n</div>"